const DATA_LAYER_CONTEXT_KEY = 'azki_datalayer_context';

export type DataLayerSessionContext = {
    vehicleFinesVehicleType?: 'car' | 'motorcycle';
    vehicleFinesPayment?: {
        recordUuids: string[];
        trackingCode: string;
        serviceFeeAmount?: number;
        fineAmount?: number;
        totalAmount?: number;
        transactionId: string;
    };
    onlineBillPayment?: {
        trackingCode: string;
        serviceFeeAmount?: number;
    };
    inspectionVehicle?: 'car' | 'motor';
    inspectionBrand?: string;
    inspectionModel?: string;
    inspectionItemId?: string;
    inspectionItemName?: string;
    batteryVehicle?: 'car' | 'motor';
    batteryBrand?: string;
    batteryModel?: string;
    batteryItemId?: string;
    batteryItemName?: string;
    batteryItemBrand?: string;
    batteryItemPrice?: number;
};

const isBrowser = () => typeof window !== 'undefined';

export const getDataLayerContext = (): DataLayerSessionContext => {
    if (!isBrowser()) {
        return {};
    }

    try {
        const raw = sessionStorage.getItem(DATA_LAYER_CONTEXT_KEY);
        return raw ? (JSON.parse(raw) as DataLayerSessionContext) : {};
    } catch {
        return {};
    }
};

export const setDataLayerContext = (patch: DataLayerSessionContext): void => {
    if (!isBrowser()) {
        return;
    }

    try {
        const current = getDataLayerContext();
        sessionStorage.setItem(DATA_LAYER_CONTEXT_KEY, JSON.stringify({ ...current, ...patch }));
    } catch {
        return;
    }
};
